import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Base } from '@stepstone-genesis/components';
import { GradientBgTwoStep } from '../../../common/GradientBgTwoStep/index.js';
import { FORM_TYPES } from '../../../../types/paramsConfig.js';
export const GradientBackground = ({ isMobile = false, variant = FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER, }) => {
    if (variant === FORM_TYPES.TWO_STEP_RETURNING) {
        return (_jsx(Base, { sx: {
                position: `${isMobile ? 'fixed' : 'absolute'}`,
                inset: 0,
                zIndex: 'zIndex0',
                pointerEvents: 'none',
                background: `linear-gradient(180deg, #ABE5E8 0%, #FFFFFF 100%)`,
            } }));
    }
    return (_jsx(Base, { sx: {
            position: 'absolute',
            inset: 0,
            zIndex: 'zIndex0',
            pointerEvents: 'none',
        }, children: _jsx(GradientBgTwoStep, {}) }));
};
//# sourceMappingURL=GradientBackground.js.map